import { Box, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";

function num(v) {
  const n = Number(v ?? 0);
  return Number.isFinite(n) ? n : 0;
}

function money(v) {
  return `₩${num(v).toLocaleString()}`;
}

function moneyNeg(v) {
  const n = num(v);
  if (n === 0) return "₩0";
  return `-₩${n.toLocaleString()}`;
}

/**
 * @param {{ detail: Record<string, unknown> | null }} props
 */
export default function CpsSettlementBreakdown({ detail }) {
  if (!detail) return null;

  const billSub = num(detail.manuscriptFee) + num(detail.manuscriptFeePlatformFee);
  const salesCount = detail.totalSalesCount ?? 0;
  const salesQty = detail.totalQuantity ?? 0;

  return (
    <Box fontSize="sm">
      <Text fontWeight="700" mb={2} color="#172940">
        [광고주 청구 내역]
      </Text>
      <TableContainer borderWidth="1px" borderRadius="md">
        <Table
          size="sm"
          variant="simple"
          sx={{ width: "100%", tableLayout: "fixed" }}
        >
          <Thead bg="gray.50">
            <Tr>
              <Th>항목</Th>
              <Th isNumeric>금액</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>원고료</Td>
              <Td isNumeric>{money(detail.manuscriptFee)}</Td>
            </Tr>
            <Tr>
              <Td>원고료 수수료</Td>
              <Td isNumeric>{money(detail.manuscriptFeePlatformFee)}</Td>
            </Tr>
            <Tr>
              <Td fontWeight="700">청구 합계</Td>
              <Td isNumeric fontWeight="700">
                {money(billSub)}
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
      <Text fontSize="xs" color="gray.600" mt={1}>
        예치금에서 차감할 금액입니다.
      </Text>

      <Text fontWeight="700" mt={5} mb={2} color="#172940">
        [광고주 정산 수익]
      </Text>
      <TableContainer borderWidth="1px" borderRadius="md">
        <Table
          size="sm"
          variant="simple"
          sx={{ width: "100%", tableLayout: "fixed" }}
        >
          <Thead bg="gray.50">
            <Tr>
              <Th>항목</Th>
              <Th isNumeric>내용</Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr>
              <Td>총 판매금액</Td>
              <Td isNumeric>{money(detail.totalSalesAmount)}</Td>
            </Tr>
            <Tr>
              <Td>판매 건수</Td>
              <Td isNumeric>{salesCount}건</Td>
            </Tr>
            <Tr>
              <Td>판매 수량</Td>
              <Td isNumeric>{salesQty}개</Td>
            </Tr>
            <Tr>
              <Td>총 클릭수</Td>
              <Td isNumeric>{num(detail.totalClicks)}회</Td>
            </Tr>
            <Tr>
              <Td>크리에이터 커미션</Td>
              <Td isNumeric>{moneyNeg(detail.totalCommission)}</Td>
            </Tr>
            <Tr>
              <Td>플랫폼 수수료</Td>
              <Td isNumeric>{moneyNeg(detail.totalPlatformFee)}</Td>
            </Tr>
            <Tr>
              <Td>ROAS</Td>
              <Td isNumeric>{num(detail.roas).toFixed(1)}%</Td>
            </Tr>
            <Tr>
              <Td fontWeight="700">정산 수익</Td>
              <Td isNumeric fontWeight="700">
                {money(detail.totalAdvertiserSettlement)}
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
}
